import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import { useAppContext } from 'context/AppContextProvider';
import useNewMessageCount from 'views/Messages/hooks/useNewMessageCount';
import { CircularProgress } from '@mui/material';

const MessageIcon = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { newMessageCount, clearCount } = useNewMessageCount(pathname);
  const { isChatInitializing, isChatAuthenticated } = useAppContext();

  useEffect(() => {
    if (pathname === '/messages') {
      clearCount();
    }
  }, [pathname, clearCount]);

  if (isChatInitializing) {
    return <CircularProgress size={14} />;
  }

  if (!isChatAuthenticated) {
    return null;
  }

  return (
    <IconButton
      aria-label='menu'
      color='inherit'
      aria-controls='dd-menu'
      aria-haspopup='true'
      onClick={() => navigate('/messages')}
    >
      <Badge badgeContent={newMessageCount} color='primary' max={10}>
        <QuestionAnswerRoundedIcon />
      </Badge>
    </IconButton>
  );
};

export default MessageIcon;
